import React from "react";

const LoadMore = ({ hasMore, visibleLoadMore, getMoreRestaurants }) =>
  (hasMore && visibleLoadMore && (
    <div className="show-more ">
      <button className="btn btn-blue " onClick={getMoreRestaurants}>
        See More
      </button>
    </div>
  )) || <noscript />;

export default LoadMore;
